import { React, useContext } from 'react';
import { AppContext } from '../../../services/AppContext';
import { useTranslation } from 'react-i18next';

const InviteReceived = ({ closeModal, invitation }) => {
    const { t } = useTranslation();
    const { apiClient, notify } = useContext(AppContext);
    const apiUrl = window.env.REACT_APP_API_URL;

    const handleRespondToInvitation = async (accept) => {
        try {
            const result = await apiClient.acceptInvitation(
                {
                    accept: accept,
                }
            );

            if (result.hasErrors) {
                return;
            }

            if (accept) {
                notify(t('pages.customers.modals.invitationAccepted'), 'success');
            } else {
                notify(t('pages.customers.modals.invitationDeclined'), 'warning');
            }

            closeModal();
        } catch (error) {
            notify(error.message, 'error');
        }
    };

    return (<div className="modal">
        <div className="modal-content">
            <h3>{t('pages.customers.modals.invitationReceived')}</h3>

            <div className='container-circle'>
                <img src={`${apiUrl}${invitation.logoUrl}`} alt={t('pages.customers.modals.companyLogoAlt')} />
            </div>

            <div className='mg-b-1'>
                <p><b>{invitation.displayName}</b> {t('pages.customers.modals.invitationMessage')}</p>
            </div>

            <div className='container'>
                <button className='mg-r-1 width-100p' onClick={() => handleRespondToInvitation(true)}>{t('pages.customers.modals.acceptButton')}</button>
                <button className='background-danger width-100p' onClick={() => handleRespondToInvitation(false)}>{t('pages.customers.modals.declineButton')}</button>
            </div>
        </div>
    </div>
    )
};

export default InviteReceived;